import { useIntl } from "react-intl";
import { SentimentLabel } from "@/common/types/SentimentLabel";
import { tokens } from "@fluentui/react-components";

interface SentimentIndicatorProps {
	sentiment: SentimentLabel | null | undefined;
}

const DOT_COLOR: Record<SentimentLabel, string> = {
	[SentimentLabel.Positive]: tokens.colorPaletteGreenForeground3,
	[SentimentLabel.Neutral]: tokens.colorNeutralForeground3,
	[SentimentLabel.Mixed]: tokens.colorStatusWarningForeground3,
	[SentimentLabel.Negative]: tokens.colorPaletteRedForeground3,
};

const LABEL_KEY: Record<SentimentLabel, string> = {
	[SentimentLabel.Positive]: "Supervisor.Sentiment.Positive",
	[SentimentLabel.Neutral]: "Supervisor.Sentiment.Neutral",
	[SentimentLabel.Mixed]: "Supervisor.Sentiment.Mixed",
	[SentimentLabel.Negative]: "Supervisor.Sentiment.Negative",
};

export const SentimentIndicator = ({ sentiment }: SentimentIndicatorProps) => {
	const intl = useIntl();

	if (sentiment == null) {
		return (
			<span role="img" aria-label={intl.formatMessage({ id: "Supervisor.Sentiment.NotAvailable" })}>
				&#8212;
			</span>
		);
	}

	const label = intl.formatMessage({ id: LABEL_KEY[sentiment] });

	return (
		<span
			role="img"
			aria-label={label}
			style={{ display: "inline-flex", alignItems: "center", gap: 6, color: DOT_COLOR[sentiment], fontWeight: tokens.fontWeightSemibold }}
		>
			<span
				aria-hidden="true"
				style={{
					width: 8,
					height: 8,
					borderRadius: "50%",
					backgroundColor: DOT_COLOR[sentiment],
					flexShrink: 0,
				}}
			/>
			{label}
		</span>
	);
};
